const TestimonialCard = (props) => {
  return (
    <li className="testimonial-card">
      <p className=" testimonial-content">
        {props.testimonial}
      </p>
      <p className="boldTitle testimonial-giver">
        {props.giver}
      </p>
    </li>
  );
};

export default TestimonialCard;
